import { z } from "zod";

export const auditEventMinimalSchema = z.object({
	id: z.string(),
	auditType: z.string(),
	createDateUTC: z.string(),
	internalUniqueId: z.string(),
});

export type AuditEventMinimal = z.infer<typeof auditEventMinimalSchema>;
